const RadioButton = ({ name, value, label, checked, onChange = null, requiredMessage = null }) => (
  <div className="form-check">
    <input 
      className="form-check-input" 
      id={name+value} 
      name={name} 
      type="radio" 
      value={value} 
      checked={checked} 
      onChange={onChange} 
      required 
      data-val="true" 
      data-val-required={requiredMessage} 
    />
    <label className="form-check-label" htmlFor={name+value}>{label}</label>
    <span className="text-danger field-validation-valid" data-valmsg-for={name} data-valmsg-replace="true"></span>
  </div>
);

export default RadioButton;
